import { useEffect, useRef, useState } from 'react';

/**
 * Görünür değilken `effects-paused` ekler (carousel, şimşek vb.)
 */
const InViewPause = ({ children, className = '', as: Tag = 'div', rootMargin = '80px' }) => {
  const ref = useRef(null);
  const [inView, setInView] = useState(true);

  useEffect(() => {
    const el = ref.current;
    if (!el || typeof IntersectionObserver === 'undefined') return undefined;

    const obs = new IntersectionObserver(
      ([entry]) => setInView(entry.isIntersecting),
      { rootMargin, threshold: 0.02 }
    );
    obs.observe(el);
    return () => obs.disconnect();
  }, [rootMargin]);

  return (
    <Tag
      ref={ref}
      className={`${className}${inView ? ' in-view' : ' effects-paused'}`.trim()}
    >
      {children}
    </Tag>
  );
};

export default InViewPause;
